import { __assign, __extends, __rest } from "tslib";
import * as React from "react";
import { View, Platform, StyleSheet, StyleProp } from "react-native";
import color from "color";
import AppbarContent, { AppbarContent as _AppbarContent } from "./AppbarContent";
import AppbarAction from "./AppbarAction";
import AppbarBackAction from "./AppbarBackAction";
import AppbarHeader, { AppbarHeader as _AppbarHeader } from "./AppbarHeader";
import { withPnmacContext } from "../Context";
import Surface from "../Surface";
import { black, white } from "../styles/colors";
import overlay from "../styles/overlay";
export var DEFAULT_APPBAR_HEIGHT = 56;
/**

 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { Appbar } from 'pnmac-universal-library';
 * import { StyleSheet } from 'react-native';
 *
 * export default class MyComponent extends React.Component {
 *   render() {
 *     return (
 *       <Appbar style={styles.bottom}>
 *         <Appbar.Action icon="archive" onPress={() => console.log('Pressed archive')} />
 *         <Appbar.Action icon="mail" onPress={() => console.log('Pressed mail')} />
 *         <Appbar.Action icon="label" onPress={() => console.log('Pressed label')} />
 *         <Appbar.Action icon="delete" onPress={() => console.log('Pressed delete')} />
 *       </Appbar>
 *     );
 *   }
 * }
 *
 * const styles = StyleSheet.create({
 *   bottom: {
 *     position: 'absolute',
 *     left: 0,
 *     right: 0,
 *     bottom: 0,
 *   },
 * });
 * ```
 */
var PnmacAppbar = /** @class */function (_super) {
  __extends(PnmacAppbar, _super);
  function PnmacAppbar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacAppbar.prototype.render = function () {
    var _a = this.props,
      children = _a.children,
      theme = _a.theme,
      dark = _a.dark,
      style = _a.style,
      rest = __rest(_a, ["children", "theme", "dark", "style"]);
    var _b = StyleSheet.flatten(style) || {},
      customBackground = _b.backgroundColor,
      _c = _b.elevation,
      elevation = _c === void 0 ? 4 : _c,
      restStyle = __rest(_b, ["backgroundColor", "elevation"]);
    var backgroundColor = theme.header;
    var shouldCenterContent = false;
    var shouldAddLeftSpacing = false;
    var shouldAddRightSpacing = false;
    if (Platform.OS === "ios") {
      var hasAppbarContent_1 = false;
      var leftItemsCount_1 = 0;
      var rightItemsCount_1 = 0;
      React.Children.forEach(children, function (child) {
        if (/*#__PURE__*/React.isValidElement(child)) {
          if (child.type === AppbarContent) {
            hasAppbarContent_1 = true;
          } else if (hasAppbarContent_1) {
            rightItemsCount_1++;
          } else {
            leftItemsCount_1++;
          }
        }
      });
      shouldCenterContent = hasAppbarContent_1 && leftItemsCount_1 < 2 && rightItemsCount_1 < 2;
      shouldAddLeftSpacing = shouldCenterContent && leftItemsCount_1 === 0;
      shouldAddRightSpacing = shouldCenterContent && rightItemsCount_1 === 0;
    }
    return /*#__PURE__*/React.createElement(Surface, __assign({
      nativeID: "surface_test",
      "data-value": "123",
      style: [{
        backgroundColor: backgroundColor
      }, styles.appbar, {
        elevation: elevation
      }, restStyle]
    }, rest), shouldAddLeftSpacing ? /*#__PURE__*/React.createElement(View, {
      style: styles.spacing
    }) : null, React.Children.toArray(children).filter(function (child) {
      return child != null && typeof child !== "boolean";
    }).map(function (child, i) {
      if (! /*#__PURE__*/React.isValidElement(child) || ![AppbarContent, AppbarAction, AppbarBackAction].includes(child.type)) {
        return child;
      }
      var props = {
        color: typeof child.props.color !== "undefined" ? child.props.color : black
      };
      if (child.type === AppbarContent) {
        props.style = [
        // Since content is not first item, add extra left margin
        i !== 0 && {
          marginLeft: 8
        }, shouldCenterContent && {
          alignItems: "center"
        }, child.props.style];
      }
      return /*#__PURE__*/React.cloneElement(child, props);
    }), shouldAddRightSpacing ? /*#__PURE__*/React.createElement(View, {
      style: styles.spacing
    }) : null);
  };
  // @component ./AppbarContent.js
  PnmacAppbar.Content = AppbarContent;
  // @component ./AppbarAction.js
  PnmacAppbar.Action = AppbarAction;
  // @component ./AppbarBackAction.js
  PnmacAppbar.BackAction = AppbarBackAction;
  // @component ./AppbarHeader.js
  PnmacAppbar.Header = AppbarHeader;
  return PnmacAppbar;
}(React.Component);
var styles = StyleSheet.create({
  appbar: {
    height: DEFAULT_APPBAR_HEIGHT,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 4,
    elevation: 4
  },
  spacing: {
    width: 48
  }
});
export default withPnmacContext(PnmacAppbar);